import Theme from '@adsk/alloy-react-theme';

export const detailsViewWrapperStyle = {
  display: 'flex',
  flexFlow: 'row wrap',
  paddingTop: '16px',
};

export const detailsViewItemStyle = {
  minHeight: '120px',
  minWidth: '200px',
  width: '33%',
  paddingRight: '20px',

  h2: {
    display: 'inline-block',
    margin: '0',
    fontSize: '14px',
    paddingBottom: '5px',
    paddingRight: '7px',
  },

  div: {
    display: 'inline-block',
  },

  p: {
    margin: '0',
    fontSize: '14px',
    color: Theme.colors.charcoal900,
  },

  svg: {
    verticalAlign: 'middle',
    color: Theme.colors.charcoal400,
  },
};

export const dividerStyle = {
  backgroundColor: Theme.colors.charcoal700,
  margin: '12px 0',
};
